import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';

export const DeleteVideButton = styled(TextButton)`
  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;
